export { default, getServerSideProps } from 'modules/website/pages/WholesalerPage'
